import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { LoggedInUserAPI, PermissionKeyEnum, UserEcosystemAPI, UserMicrosystemAPI, Zone } from '../types';

export interface CurrentUserState {
  isLoading: boolean;
  currentUser: LoggedInUserAPI | null;
  currentEcosystem: UserEcosystemAPI | null;
  currentMicroSystem: UserMicrosystemAPI | null;
  currentUserType: string | '';
  currentZone?: Zone;
  userPermissions: Record<
    PermissionKeyEnum,
    {
      description: string;
      reason: string;
      status: string;
      value: 'show' | 'disable';
    }
  > | null;
  setIsLoading: (isLoading: boolean) => void;
  setCurrentUser: (userData: LoggedInUserAPI) => void;
  setCurrentEcosystem: (ecosysData: UserEcosystemAPI) => void;
  setCurrentMicrosystem: (microsysData: UserMicrosystemAPI) => void;
  setCurrentUserType: (userType: string) => void;
  setCurrentZone: (zoneData: Zone) => void;
  setUserPermissions: (
    userPermissions: Record<
      PermissionKeyEnum,
      {
        description: string;
        reason: string;
        status: string;
        value: 'show' | 'disable';
      }
    >,
  ) => void;
  reset: () => void;
}

const initialState = {
  isLoading: true,
  currentUser: null,
  currentEcosystem: null,
  currentMicroSystem: null,
  currentUserType: '',
  userPermissions: null,
};

export const useCurrentUserStore = create<CurrentUserState>()(
  persist(
    (set) => ({
      ...initialState,
      setIsLoading: (newData) => set(() => ({ isLoading: newData })),
      setCurrentUser: (newData) => set(() => ({ currentUser: newData })),
      setCurrentEcosystem: (newData) => set(() => ({ currentEcosystem: newData })),
      setCurrentMicrosystem: (newData) => set(() => ({ currentMicroSystem: newData })),
      setCurrentUserType: (newData) => set(() => ({ currentUserType: newData })),
      setCurrentZone: (newData) => set(() => ({ currentZone: newData })),
      setUserPermissions: (newData) => set(() => ({ userPermissions: newData })),
      reset: () => set(initialState),
    }),
    {
      name: 'currentUser',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
